import { FC, ReactNode } from "react";
import Carrier from "@Components/Carrier/Carrier";

interface MobileBottomDrawerProps {
  title: string;
  barContent: ReactNode;
  drawerContent: ReactNode;
}

const MobileBottomDrawer: FC<MobileBottomDrawerProps> = ({ title, barContent, drawerContent }) => {
  return (
    <Carrier
      label={title}
      renderTrigger={({ open }) => (
        <div className="fixed bottom-0 start-0 right-0 z-50 bg-background-default rounded-t-xl shadow-[0_-4px_20px_rgba(0,0,0,0.12)] md:hidden">
          <button type="button" className="w-full flex flex-col items-center pt-2 pb-0 focus:outline-none" onClick={open}>
            <div className="w-10 h-0.5 rounded-full bg-border-hover mb-1" />
          </button>
          {barContent}
        </div>
      )}
      renderSheet={() => <div className="flex-1 overflow-y-auto px-4 py-4">{drawerContent}</div>}
    />
  );
};

export default MobileBottomDrawer;
